import { Phone, CalendarCheck } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import { SITE, waLink } from "../data/site";
import { useLang } from "../i18n";

export function FloatingWhatsApp() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="wa-pulse fixed z-40 bottom-20 md:bottom-6 right-4 md:right-6 w-14 h-14 rounded-full bg-wa text-white flex items-center justify-center shadow-xl hover:scale-105 transition-transform"
    >
      <FaWhatsapp size={26} />
    </a>
  );
}

export function StickyMobileBar() {
  const { t } = useLang();
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-navy/95 backdrop-blur border-t border-white/10 grid grid-cols-3" data-testid="sticky-mobile-cta">
      <a href={`tel:${SITE.phoneTel}`} data-testid="sticky-call-btn" className="flex flex-col items-center gap-1 py-2.5 text-white text-[11px] font-bold">
        <Phone size={17} className="text-gold" /> {t("stickyCall")}
      </a>
      <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="sticky-whatsapp-btn" className="flex flex-col items-center gap-1 py-2.5 text-white text-[11px] font-bold border-x border-white/10">
        <FaWhatsapp size={17} className="text-wa" /> {t("stickyWa")}
      </a>
      <Link to="/contact" data-testid="sticky-book-btn" className="flex flex-col items-center gap-1 py-2.5 text-white text-[11px] font-bold">
        <CalendarCheck size={17} className="text-royal-300" /> {t("stickyBook")}
      </Link>
    </div>
  );
}
